import React from 'react';

// Pin + speed lines mark
export const LogoMark = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} aria-label="Delibery 7">
    <path d="M4 28h14" stroke="#EE3B36" strokeWidth="4" strokeLinecap="round" />
    <path d="M8 38h12" stroke="#EE3B36" strokeWidth="4" strokeLinecap="round" />
    <path d="M2 48h16" stroke="#EE3B36" strokeWidth="4" strokeLinecap="round" />
    <path d="M40 6C28.9 6 20 14.9 20 26c0 14 20 32 20 32s20-18 20-32C60 14.9 51.1 6 40 6z" fill="#EE3B36" />
    <circle cx="40" cy="26" r="9" fill="#fff" />
    <circle cx="40" cy="26" r="4" fill="#1E2130" />
  </svg>
);

// Full logo: mark + wordmark
const Logo = ({ size = 'md', dark = false, className = '' }) => {
  const sizes = {
    sm: { mark: 34, title: 'text-lg', sub: 'text-[11px]', gap: 'gap-1.5' },
    md: { mark: 46, title: 'text-2xl', sub: 'text-[13px]', gap: 'gap-2' },
    lg: { mark: 72, title: 'text-4xl', sub: 'text-lg', gap: 'gap-3' },
    xl: { mark: 96, title: 'text-5xl', sub: 'text-2xl', gap: 'gap-3' },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center ${s.gap} ${className}`}>
      <LogoMark size={s.mark} />
      <div className="leading-none">
        <div className={`font-extrabold tracking-tight ${s.title} ${dark ? 'text-white' : 'text-[#1E2130]'}`}>
          Delibery <span className="text-[#EE3B36]">7</span>
        </div>
        <div className={`font-bold text-[#EE3B36] text-right ${s.sub} -mt-0.5`}>Tocoa</div>
      </div>
    </div>
  );
};

// Stacked logo for splash screens
export const LogoStacked = ({ dark = false, markSize = 96 }) => (
  <div className="flex flex-col items-center">
    <LogoMark size={markSize} />
    <div className={`mt-2 text-4xl font-extrabold tracking-tight leading-none ${dark ? 'text-white' : 'text-[#1E2130]'}`}>
      Delibery <span className="text-[#EE3B36]">7</span>
    </div>
    <div className="text-xl font-bold text-[#EE3B36] leading-none mt-1">Tocoa</div>
  </div>
);

export const TocoaScript = ({ light = false, className = '' }) => (
  <div className={`font-script ${light ? 'text-white' : 'text-[#EE3B36]'} ${className}`}>
    Tocoa <span className="inline-block">&#9825;</span>
  </div>
);

export default Logo;
